export const PLAN_NAMES = ["BASIC", "EXTENDED"];
